import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e4010be2")

_pushScopeId("data-v-e4010be2")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-grow flex flex-col justify-between h-screen right-container" }
const _hoisted_3 = { class: "flex-grow flex flex-col items-start bg-primary-100 overflow-y-scroll px-12 pt-12" }
const _hoisted_4 = {
  key: 0,
  class: "bg-white hidden lg:flex flex-col mb-4 px-4 py-3 rounded-md"
}
const _hoisted_5 = { class: "flex flex-row gap-2 justify-center items-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "新しい導入スクールを登録", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "全導入スクールをCSV出力", -1)
const _hoisted_8 = { class: "panel-container rounded-md bg-white pb-2 mb-16" }
const _hoisted_9 = { class: "flex items-center w-full table-header-color px-4 py-3" }
const _hoisted_10 = { class: "mr-2" }
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-8"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "text-gray-500 text-sm" }, "導入スクール情報取得中...", -1)
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 導入スクールの削除 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" スクール情報をCSVエクスポート ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" スタッフ情報をCSVエクスポート ")
const _hoisted_17 = { class: "text-gray-500 text-sm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavBar = _resolveComponent("MNavBar")
  const _component_MHeaderPanel = _resolveComponent("MHeaderPanel")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_loading_icon = _resolveComponent("m-loading-icon")
  const _component_m_table = _resolveComponent("m-table")
  const _component_MScAddModal = _resolveComponent("MScAddModal")
  const _component_msc_edit_modal = _resolveComponent("msc-edit-modal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_MNavBar),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_MHeaderPanel, {
          title: "導入スクール管理",
          breadcrumbs: []
        }),
        _createVNode("main", _hoisted_3, [
          (_ctx.isSuperAdmin || _ctx.isServiceProvider)
            ? (_openBlock(), _createBlock("section", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_m_button, {
                    color: "primary-500",
                    "hover-color": "primary-600",
                    onClick: _ctx.showAddModal
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_m_icon, {
                        type: "plus",
                        width: "4",
                        class: "mr-2"
                      }),
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  (_ctx.isSuperAdmin || _ctx.isServiceProvider)
                    ? (_openBlock(), _createBlock(_component_m_button, {
                        key: 0,
                        color: "primary-500",
                        "hover-color": "primary-600",
                        class: "",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exportSchoolDetailsToCsv({ exportAll: true })))
                      }, {
                        default: _withId(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("section", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchKeyword = $event)),
                  type: "search",
                  name: "searchSchool",
                  placeholder: 
                  `ID、名称、${_ctx.isSchool ? '管理職' : 'オーナー'}で検索...`
                ,
                  class: "w-64 bg-white rounded border border-white focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-2 leading-8 transition-colors duration-300"
                }, null, 8, ["placeholder"]), [
                  [_vModelText, _ctx.searchKeyword]
                ])
              ])
            ]),
            (_ctx.load)
              ? (_openBlock(), _createBlock("div", _hoisted_11, [
                  _createVNode(_component_m_loading_icon),
                  _hoisted_12
                ]))
              : (_openBlock(), _createBlock(_component_m_table, {
                  key: 1,
                  datas: _ctx.filteredSchools,
                  definitions: _ctx.definitions,
                  "count-per-page": 40,
                  "default-sort-key": "name",
                  editable: _ctx.isSuperAdmin || _ctx.isServiceProvider,
                  selectable: "",
                  "selected-ids": _ctx.selectedIds,
                  onChange: _ctx.changeSelectedId,
                  onSelect: _ctx.showEditModal
                }, {
                  footer: _withId(() => [
                    _createVNode("div", _hoisted_13, [
                      _createVNode(_component_m_button, {
                        color: "red-400",
                        "hover-color": "red-500",
                        outline: "",
                        class: "mr-6",
                        disabled: _ctx.selectedIds.length != 1,
                        onClick: _ctx.deleteSchool
                      }, {
                        default: _withId(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"]),
                      _createVNode(_component_m_button, {
                        outline: "",
                        class: "mr-6",
                        disabled: _ctx.selectedIds.length === 0,
                        onClick: _ctx.exportSchoolDetailsToCsv
                      }, {
                        default: _withId(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"]),
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createBlock(_component_m_button, {
                            key: 0,
                            outline: "",
                            class: "mr-6",
                            disabled: _ctx.selectedIds.length === 0,
                            onClick: _ctx.exportTutorDetailsToCsv
                          }, {
                            default: _withId(() => [
                              _hoisted_16
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode("p", _hoisted_17, _toDisplayString(`${_ctx.selectedIds.length}スクール選択中`), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["datas", "definitions", "editable", "selected-ids", "onChange", "onSelect"]))
          ])
        ])
      ])
    ]),
    (
      (_ctx.isDisplayedAddSchoolModal && _ctx.isSuperAdmin) ||
        (_ctx.isDisplayedAddSchoolModal && _ctx.isServiceProvider)
    )
      ? (_openBlock(), _createBlock(_component_MScAddModal, {
          key: 0,
          schools: _ctx.schools,
          targets: _ctx.targets,
          "is-super-admin": _ctx.isSuperAdmin,
          "is-service-provider": _ctx.isServiceProvider,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDisplayedAddSchoolModal = false))
        }, null, 8, ["schools", "targets", "is-super-admin", "is-service-provider"]))
      : _createCommentVNode("", true),
    (
      (_ctx.isDisplayedEditSchoolModal &&
        _ctx.selectedSchool &&
        _ctx.selectedSchoolConfig &&
        _ctx.isSuperAdmin) ||
        (_ctx.isDisplayedEditSchoolModal &&
          _ctx.selectedSchool &&
          _ctx.selectedSchoolConfig &&
          _ctx.isServiceProvider)
    )
      ? (_openBlock(), _createBlock(_component_msc_edit_modal, {
          key: 1,
          schools: _ctx.schools,
          targets: _ctx.targets,
          school: _ctx.selectedSchool,
          "school-config": _ctx.selectedSchoolConfig,
          tutors: _ctx.selectedTutors,
          "is-super-admin": _ctx.isSuperAdmin,
          "is-service-provider": _ctx.isServiceProvider,
          onClose: _ctx.onEditModalClose
        }, null, 8, ["schools", "targets", "school", "school-config", "tutors", "is-super-admin", "is-service-provider", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
})